import CropperUpload from './CropperUpload';
import './style/index.less';

export type { CropImage, CropBox } from './CropperUpload';
export default CropperUpload;
